import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';
import * as firebase from 'firebase';
// import {  FirebaseListObservable } from 'angularfire2/database-deprecated';
// import { FirebaseObjectObservable } from 'angularfire2/database-deprecated';
import { 
  AngularFirestore 
} from 'angularfire2/firestore';
// import { UserserviceService } from '../userservice.service';
import { UserService } from '../core/user.service';
import { AuthService } from '../core/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FirebaseUserModel } from '../core/user.model';
import { SearchService } from '../search.service';

@Component({
  selector: 'app-stuhome',
  templateUrl: './stuhome.component.html',
  styleUrls: ['./stuhome.component.css']
})
export class StuhomeComponent implements OnInit {

  search:any=[];
  array:any=[];
  placeorder1:any=[];
  dat;
  i=0;
  value;
  searcharray:any=[];
  month;
  email;
  uid;
  success=null;
  fail=null;
  bookname;
  authorname;
  vieword:any=[];
  returndate;
  issuedate;
  fine;
  authn;
  bkn;
  retd;
  curd;
  selectindex;
  bkid;

  logout(){
    this.authService.doLogout()
    .then((res) => {
      this.location.back();
    }, (error) => {
      console.log("Logout error", error);
    });
  }

  constructor(public db1: AngularFirestore,public db: AngularFireDatabase,
    public userService: UserService,
    public authService: AuthService,
    private route: ActivatedRoute,
    private location : Location,
    private fb: FormBuilder,
    public service:SearchService) {

      this.array = db1.collection("books").valueChanges();


      var user = firebase.auth().currentUser;
      if (user != null) {
        // this.name1 = user.displayName;
         this.email = user.email;
        console.log("kbk",user.email)
        // this.emailVerified = user.emailVerified;
        this.uid = user.uid; 
         var res = this.email.split("@");
         res.splice(1,1);
        // console.log(res)
         this.email=res[0];
         this.vieword = db1.collection(this.uid).valueChanges();

         db1.collection(this.uid).ref.get().then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              // console.log(doc.id, " => ", doc.data());
          });
      });

      }

      
     }


 booksearch()
 {
  var y= document.getElementById("ord");
  y.style.display = "none";
  
  var z= document.getElementById("vord");
  z.style.display = "none";

  var z1= document.getElementById("rbook");
  z1.style.display = "none";

  var x = document.getElementById("myDIV"); 
  if (x.style.display === "none") {
      x.style.display = "block";
  } else {
      x.style.display = "none";
  }


}


searchname(value)
{
   this.search=[]
  var i=0
    //  this.service.
     this.db1.collection("books").ref.get().then((querySnapshot)=> {
      querySnapshot.forEach((doc)=> {

        if(doc.data().title.indexOf(value)>=0)
        {
         console.log(doc.data());
         this.search[i]=doc.data()
         i++;
         console.log(this.search)
        }
      });
  });
}


 
placeorder()
{
  var y= document.getElementById("myDIV");
  var z= document.getElementById("vord");
  z.style.display = "none";
  var z1= document.getElementById("rbook");
  z1.style.display = "none";

  y.style.display = "none";

 var x = document.getElementById("ord"); 
 if (x.style.display === "none") {
     x.style.display = "block";
 } else {
     x.style.display = "none";
 }

 

 this.dat=new Date();
 this.month=new Date(new Date(this.dat).setDate(this.dat.getDate()+30)).getTime();
 var timestamp=new Date().getTime();

 var todate=new Date(timestamp).getDate();
 var tomonth=new Date(timestamp).getMonth();
 var a1 = tomonth+1
 var toyear=new Date(timestamp).getFullYear();
 this.issuedate=todate+'/'+a1+'/'+toyear;
 var todate=new Date(this.month).getDate();
 var tomonth=new Date(this.month).getMonth();
 var a = tomonth+1
 var toyear=new Date(this.month).getFullYear();
 this.returndate=todate+'/'+a+'/'+toyear;

}

returnbook()
{
  var y= document.getElementById("myDIV");
  var z= document.getElementById("vord");
  z.style.display = "none";
  y.style.display = "none";
  var z1= document.getElementById("ord");
  z1.style.display = "none";

 var x = document.getElementById("rbook"); 
 if (x.style.display === "none") {
     x.style.display = "block";
 } else {
     x.style.display = "none";
 }
}

place(name,authname)
{

     this.bookname=name;
     this.authorname=authname;
     let i=1;
     this.success=null;
     this.fail=null;
    //  i--;
     this.db1.collection("books").ref.get().then((querySnapshot)=> {
      querySnapshot.forEach((doc)=> {

        let quan=doc.data().quantity;
        let bk=doc.data().bookid;
        this.fail="This book is not available now !"


        // this.db1.collection("returnbooks").ref.get().then((querySnapshot)=> {
        // querySnapshot.forEach((doc1)=> {

        //   let 


if(doc.data().title==name&&doc.data().authorname==authname && doc.data().quantity>0)
{
          this.db1.collection(this.uid).doc(name).ref.get().then((doc)=> {
            if (doc.exists) {
              console.log("already exists")
              this.fail="This order has already been placed !"
            }
            else{
              
            this.db1.collection(this.uid).doc(name).set({
            bookid:bk,
            bookname:name,
            authorname:authname,
            sid:this.uid,
            currentdate:this.issuedate,
            returndate:this.returndate
        })
        // var bid=doc.data().bookid;
        
        // let orquan=quan;
        quan=quan-i
        this.db1.collection("books").doc(bk).update({
          "quantity": quan,
          
    })
    .then(()=> {
      console.log("Document successfully updated!");
      this.success="Order successfully Placed"
    });
            }

        // To update 
      });



}

      });
  });

// });
// });
    // this.i++;

}

vieworder()
{

  var y= document.getElementById("myDIV");
  y.style.display = "none";

  var z= document.getElementById("ord");
  z.style.display = "none";

  var z1= document.getElementById("rbook");
  z1.style.display = "none";

 var x = document.getElementById("vord"); 
 if (x.style.display === "none") {
     x.style.display = "block";
 } else {
     x.style.display = "none";
 }

}

track(date,authname,bkname,retdate)
{
  this.authn="";
  this.bkn="";
  this.retd="";
  this.curd="";
  // this.bkid="";
  this.fine=0;

  var ar=date.split("/")
  var rdate=new Date(ar[2],ar[1],ar[0]).getTime()
  var ti=new Date().getTime()
  var d=new Date(ti).getDate()+1;
  var m=new Date(ti).getMonth();
  var y=new Date(ti).getFullYear();
  var ti=new Date(y,m,d).getTime()
  var t=ti-rdate;
var cd=86400000;
var day=Math.floor(t/cd)
if((day-31)>0)
{
  var extraday=day-31
  this.fine=extraday*5;

  // console.log(fine+" rs")
}
this.authn=authname;
this.bkn=bkname;
this.retd=retdate;
this.curd=date;
// this.bkid=bkid;
// this.fine=0;

}


return(date,authname,bkname,retdate,bkid,i)
{
  this.selectindex=i;
  this.authn="";
  this.bkn="";
  this.retd="";
  this.curd="";
  this.bkid="";
  this.fine=0;

  var ar=date.split("/")
  var rdate=new Date(ar[2],ar[1],ar[0]).getTime()
  var ti=new Date().getTime()
  var d=new Date(ti).getDate()+1;
  var m=new Date(ti).getMonth();
  var y=new Date(ti).getFullYear();
  var ti=new Date(y,m,d).getTime()
  var t=ti-rdate;
var cd=86400000;
var day=Math.floor(t/cd)
if((day-31)>0)
{
  var extraday=day-31
  this.fine=extraday*5;

  // console.log(fine+" rs")
}
this.authn=authname;
this.bkn=bkname;
this.retd=retdate;
this.curd=date;
this.bkid=bkid;
// this.fine=0;

}

returnbooks()
{
  this.db1.collection(this.uid).doc(this.bkn).delete().then(()=> {
    console.log("Document successfully deleted!");
    console.log(this.email+"--"+this.bkn+"--"+this.authn)
    this.db1.collection("returnbooks").doc(this.email+"--"+this.bkn+"--"+this.authn).set({
      id:this.email+"--"+this.bkn+"--"+this.authn,
      bookid:this.bkid,
      authorname:this.authn,
      bookname:this.bkn,
      returndate:this.retd,
      currentdate:this.curd,
      fine:this.fine
  })
  .then(()=> {
      console.log("Document successfully written!");
  })
  .catch((error)=> {
      console.error("Error writing document: ", error);
  });

}).catch((error)=> {
    console.error("Error removing document: ", error);
});
}

  ngOnInit() {
  console.log(this.email+"--"+this.bkn+"--"+this.authn)

  }

}
